import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import "./AgendaItems.module.scss";
import customIsoString from "utilities/custom-iso-string";

/**
 * Import components
 */

import Button from "components/UI/Button/Button";

/**
 * Import FontAwesome
 */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import getScheduleByDay from "selectors/schedule/day";

import destroyEvent from "actions/event/destroy";

const months = [
    "januari",
    "februari",
    "maart",
    "april",
    "mei",
    "juni",
    "juli",
    "augustus",
    "september",
    "oktober",
    "november",
    "december"
];

const mapStateToProps = (state, props) => {
    const customProps = {
        date: new Date(state.new_homework.date)
    };
    return {
        events: getScheduleByDay(state, customProps),
        date: customProps.date
    };
};

const mapDispatchToProps = {
    destroyEvent
};

class AgendaItems extends Component {
    constructor() {
        super();

        this.state = {
            showPopup: false,
            selectedIndex: null
        };

        this.openImage = this.openImage.bind(this);
        this.toggleClearPopup = this.toggleClearPopup.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.destroyItem = this.destroyItem.bind(this);
        this.setRef = this.setRef.bind(this);

        this.inputRefs = [];
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    openImage(data) {
        var image = new Image();
        image.src = data;
        var w = window.open("");
        w.document.write(image.outerHTML);
    }

    toggleClearPopup(index) {
        if (this.state.showPopup) {
            document.removeEventListener("mousedown", this.handleClickOutside);
        } else {
            document.addEventListener("mousedown", this.handleClickOutside);
        }
        this.setState(prevState => {
            return {
                showPopup: !prevState.showPopup,
                selectedIndex: prevState.selectedIndex == null ? index : null
            };
        });
    }

    handleClickOutside(event) {
        let hit = false;
        this.inputRefs.forEach(ref => {
            if (ref.contains(event.target)) {
                hit = true;
            }
        });

        if (!hit) {
            this.setState({
                showPopup: false,
                selectedIndex: null
            });
            document.removeEventListener("mousedown", this.handleClickOutside);
        }
    }

    destroyItem(item, editMode, items, timelessItems) {
        let confirmation = confirm(
            "Weet je zeker dat je dit agenda item wilt verwijderen?"
        );

        if (confirmation) {
            if (item.isRecurring) {
                this.props.destroyEvent(item.id, {
                    id: item.id,
                    redit: editMode ? editMode : "single",
                    origid: item.origid,
                    ristart: customIsoString(this.props.date, true),
                    startDateUtc: customIsoString(this.props.date, true)
                });
            } else {
                this.props.destroyEvent(item.id, {
                    id: item.id,
                    redit: ""
                });
            }
            if (
                (items.length <= 1 && timelessItems.length == 0) ||
                (items.length == 0 && timelessItems.length <= 1)
            ) {
                this.props.toggleAgendaItemPopup();
            }
        }
    }

    setRef(ref) {
        this.inputRefs.push(ref);
    }

    render() {
        let items = this.props.events
            .filter(item => item.timeslot == 99 && item.start_at)
            .sort((a, b) => parseInt(a.start_at) - parseInt(b.start_at));
        let timelessItems = this.props.events.filter(
            item => item.timeslot == 99 && !item.start_at
        );

        timelessItems.map(timelessItem => {
            items.unshift(timelessItem);
        });

        return (
            <div styleName="input-content">
                <div styleName="top-bar">
                    <h1 styleName="title">Agenda items</h1>
                </div>
                <div styleName="card-content">
                    <div styleName="date">
                        <p>
                            {this.props.date.getDate()}{" "}
                            {months[this.props.date.getMonth()]}
                        </p>
                    </div>
                    {items.map((item, index) => (
                        <div key={index} styleName="agenda-item">
                            <div styleName="text">
                                <div styleName="left">
                                    <p>
                                        <b>{item.description}</b>
                                    </p>
                                </div>
                                <div styleName="right">
                                    {item.start_at && (
                                        <p>
                                            {item.start_at} - {item.end_at}
                                        </p>
                                    )}
                                    <div
                                        styleName="popup-wrapper"
                                        onClick={() =>
                                            this.toggleClearPopup(index)
                                        }
                                    >
                                        <FontAwesomeIcon
                                            styleName="icon"
                                            icon={["far", "ellipsis-h"]}
                                        />
                                        <div
                                            styleName={`popup ${
                                                this.state.showPopup &&
                                                this.state.selectedIndex ===
                                                    index
                                                    ? ""
                                                    : "hidden"
                                            }`}
                                            style={
                                                item.isRecurring
                                                    ? { height: "96px" }
                                                    : { height: "64px" }
                                            }
                                        >
                                            <div
                                                styleName="options"
                                                ref={this.setRef}
                                            >
                                                <div
                                                    styleName="option"
                                                    onClick={() =>
                                                        this.props.handleEdit(
                                                            item.id
                                                        )
                                                    }
                                                >
                                                    <p>Wijzigen</p>
                                                </div>
                                                {item.isRecurring ? (
                                                    <Fragment>
                                                        <div
                                                            styleName="option red"
                                                            onClick={() =>
                                                                this.destroyItem(
                                                                    item,
                                                                    "single",
                                                                    items,
                                                                    timelessItems
                                                                )
                                                            }
                                                        >
                                                            <p>
                                                                Verwijder alleen
                                                                op deze plaats
                                                            </p>
                                                        </div>
                                                        <div
                                                            styleName="option red"
                                                            onClick={() =>
                                                                this.destroyItem(
                                                                    item,
                                                                    "future",
                                                                    items,
                                                                    timelessItems
                                                                )
                                                            }
                                                        >
                                                            <p>
                                                                Verwijder vanaf
                                                                hier
                                                            </p>
                                                        </div>
                                                    </Fragment>
                                                ) : (
                                                    <div
                                                        styleName="option red"
                                                        onClick={() =>
                                                            this.destroyItem(
                                                                item,
                                                                "single",
                                                                items,
                                                                timelessItems
                                                            )
                                                        }
                                                    >
                                                        <p>Verwijder</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div styleName="description">
                                <p>{item.note}</p>
                            </div>
                            {item.image && (
                                <Button
                                    title="Bijlage bekijken"
                                    normal
                                    style={{
                                        background: "#e5e5e5",
                                        color: "#0088fe",
                                        borderRadius: "3px",
                                        height: "26px",
                                        width: "202px",
                                        padding: "0"
                                    }}
                                    icon={["fal", "paperclip"]}
                                    smallIcon
                                    handleClick={() =>
                                        this.openImage(item.image)
                                    }
                                />
                            )}
                        </div>
                    ))}
                    <div
                        styleName="button"
                        onClick={() => this.props.handlePlanClick()}
                    >
                        <p>Agenda item toevoegen</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AgendaItems);
